import type { NotificationCondition } from 'types/templateNotificationConditions';
import type { ConditionType, HeliosNotificationConditionsState } from '..';

export const addConditionToIndex = (
  state: HeliosNotificationConditionsState,
  {
    payload,
  }: {
    payload: {
      type: ConditionType;
      index: number;
      condition: NotificationCondition;
    };
  }
) => {
  if (state[payload.type]?.conditions) {
    state[payload.type]!.conditions!.splice(payload.index + 1, 0, payload.condition);
  }
};
